import {combineReducers} from 'redux'
import Immutable from 'seamless-immutable'
import {isNil} from "lodash"
import types from 'actions/types'

const locale = (state = 'en-gb', action) => {
  switch (action.type) {
    case types.SETTINGS_LOCALE:
      return action.locale
    default:
      return state
  }
}

const dateFormat = (state = 'L', action) => {
  switch (action.type) {
    case types.SETTINGS_DATE_FORMAT:
      return action.dateFormat
    default:
      return state
  }
}

const timeFormat = (state = 'HH:mm', action) => {
  switch (action.type) {
    case types.SETTINGS_TIME_FORMAT:
      return action.timeFormat
    default:
      return state
  }
}

const currencyFormat = (state = 'L', action) => {
  switch (action.type) {
    case types.SETTINGS_CURRENCY_FORMAT:
      return action.currencyFormat
    default:
      return state
  }
}

const currencyPrecision = (state = 2, action) => {
  switch (action.type) {
    case types.SETTINGS_CURRENCY_PRECISION:
      return action.currencyPrecision
    default:
      return state
  }
}

const globalCurrencies = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.SETTINGS_GLOBAL_CURRENCY_SUCCESS:
      return action.data
    default:
      return state
  }
}

const prefixes = (state = [], action) => {
  switch (action.type) {
    case types.SETTINGS_PREFIXES_READ_SUCCESS:
      return action.data
    case types.SETTINGS_PREFIX_UPDATE_SUCCESS:
      if (isNil(action.data)) {
        return null
      }
      if (isNil(action.data.value)) {
        return state.filter(p => p.id !== action.data.id)
      }
      return [...state.filter(p => p.id !== action.data.id), action.data]
    default:
      return state
  }
}

const playNotificationSound = (state = true, action) => {
  switch (action.type) {
    case types.SETTINGS_PLAY_NOTIFICATION_SOUND_TOGGLE:
      return !state
    default:
      return state
  }
}

export const sendAutomaticReminders = (state = true, action) => {
  switch (action.type) {
    case types.SETTINGS_SEND_AUTOMATIC_REMINDERS_TOGGLE:
      return !state
    default:
      return state
  }
}

export const authSettings = (state = {}, action) => {
  switch (action.type) {
    case types.SETTINGS_AUTH_SETTINGS_UPDATE_SUCCESS:
    case types.SETTINGS_AUTH_SETTINGS_READ_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const authUserSettings = (state = [], action) => {
  switch (action.type) {
    case types.SETTINGS_AUTH_USER_SETTINGS_READ_SUCCESS:
      return action.data
    case types.TFA_RESET_SUCCESS:
      return state.map(user => {
        return {
          ...user,
          totpEnabled: user.userId !== action.userId && user.totpEnabled,
        }
      })
    default:
      return state
  }
}

export default combineReducers({
  locale,
  dateFormat,
  timeFormat,
  currencyFormat,
  currencyPrecision,
  globalCurrencies,
  prefixes,
  playNotificationSound,
  sendAutomaticReminders,
  authSettings,
  authUserSettings,
})
